import { createSlice } from "@reduxjs/toolkit";
import { getChatList, joinChat, getChatMessages } from "./chatService";

// Initial state
const initialState = {
  chatList: [],
  currentChat: null,
  chatMessages: [],
  loading: false,
  error: null,
};

// Chat slice
const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    clearChatErrors: (state) => {
      state.error = null;
    },
    clearChatData: (state) => {
      state.chatList = [];
      state.currentChat = null;
      state.chatMessages = [];
      state.loading = false;
      state.error = null;
    },
    setCurrentChat: (state, action) => {
      state.currentChat = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Get Chat List
    builder
      .addCase(getChatList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getChatList.fulfilled, (state, action) => {
        state.loading = false;
        state.chatList = action.payload.data;
      })
      .addCase(getChatList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Join Chat
      .addCase(joinChat.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(joinChat.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.data) {
          state.currentChat = action.payload.data;
          // Optionally add to chat list if needed
          const chatExists = state.chatList.some(
            (chat) => chat.id === action.payload.data.id
          );
          if (!chatExists) {
            state.chatList = [action.payload.data, ...state.chatList];
          }
        }
      })
      .addCase(joinChat.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get Chat Messages
      .addCase(getChatMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getChatMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.chatMessages = action.payload.data;
      })
      .addCase(getChatMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearChatErrors, clearChatData, setCurrentChat } =
  chatSlice.actions;
export default chatSlice.reducer;
